// CONSTANTS are all caps.
const NS = 'AccordionBlock';
const CLS = 'accordionBlock';
const BLK = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out ./loadBlk.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
// import rAccordionBlock from './AccordionBlock.jsx';
// import React from 'react';
// import ReactDOM from 'react-dom';
import {utils} from '../../../../global/js/utils.js';
// openAccordionId=collapse-monthly
export class AccordionBlock {
	constructor(el) {
		// $el is the blk node return by the loadAccordionBlock function
		this.el = el;
	}

	init() {
		this.setAccordionBlock();
		this.openAccordion();
	}

	setAccordionBlock() {
		if($(this.el).find('.cell').length <= 4) {
			console.log($('.cell'));
			$(this.el).find('.accordionBlock-more').addClass('d-none');
		}

		$(this.el).find('.accordionBlock-more').on('click', () => {
			$(this.el).find('.accordionBlock-list').removeClass('default');
			$(this.el).find('.accordionBlock-more').addClass('d-none');
		});
		// Add Some logic here
	}

	openAccordion() {
		const query = utils.queryStringParsed(location.search);
		this.openAccordionId = query.openAccordionId;

		console.log(this.openAccordionId);
		if(this.openAccordionId && this.openAccordionId.length > 0) {
			$(`#${this.openAccordionId}`).addClass('show');
			let $headingEl = $(`#${this.openAccordionId}`).siblings();

			// let delta = $('.siteHeader').hasClass('fixedState') ? $('.siteHeader').height() : 0;
			let delta = 0;
			let deltaAttr = $('.siteHeader').attr('data-sticky');
			if (typeof deltaAttr !== 'undefined' && deltaAttr !== 'false') {
				delta = $('.siteHeader').height();
			}
			let offsetHeader = $headingEl.offset().top - (delta * 2) - 16;

			$(document).ready(() => {
				setTimeout(() => {
					// scroll
					if( $headingEl.length ) {
						$('html, body').stop().animate({
							scrollTop: offsetHeader,
						}, 1000);
					}
				}, 3000);
			});
		}
	}

	// scrollToFootnote(e) {
	// 	let headerHeight = $('.siteHeader').length === 0
	// 						? 0
	// 						: $('.siteHeader').height();

	// 	let offset1 = $($('.accordionBlock-heading')[0]).offset().top;

	// 	$('.accordionBlock-heading').each((index, el) => {
	// 		let currentOffset = offset1 + index * 70;

	// 		$(el).data('initoffset', currentOffset);

	// 		$(el).on('click', (e) => {
	// 			let offset = 0 - headerHeight;
	// 			$('html,body').animate({
	// 				scrollTop: $(e.currentTarget).data('initoffset') + offset,
	// 			}, 500);
	// 		});
	// 	});
	// }
	// Add more functions like on above here
}
